export const formatShortDate = (date, fallback = '-') => {
    if (!date) return fallback
    const d = new Date(date)
    return d.toLocaleDateString([], { year: '2-digit', month: '2-digit', day: '2-digit' })
}

export const formatDateTime = (dateStr, language = 'es') => {
    if (!dateStr) return '-'
    const date = new Date(dateStr)
    return date.toLocaleString(language === 'pt' ? 'pt-BR' : 'es-MX', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    })
}

export const getCurrencySymbol = (currency) => {
    switch (currency) {
        case 'BRL':
        case 'R$':
            return 'R$'
        default:
            return '$'
    }
}

export const formatCurrency = (amount, currency, fallback) => {
    const symbol = getCurrencySymbol(currency)
    const defaultFallback = fallback !== undefined ? fallback : symbol + '0.00'
    const num = parseFloat(amount)
    if (isNaN(num)) return defaultFallback
    return symbol + num.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}

export const formatMonthYear = (date) => {
    if (!date) return ''
    const d = new Date(date)
    const str = d.toLocaleDateString([], { year: 'numeric', month: 'long' })
    return str.charAt(0).toUpperCase() + str.slice(1)
}

const STATEMENT_STATUS_CLASSES = {
    BILLED: 'bg-green-100 text-green-800',
    NOTIFIED: 'bg-blue-100 text-blue-800',
    FILES_READY: 'bg-yellow-100 text-yellow-800',
    NOT_NOTIFIED: 'bg-red-100 text-red-800',
    GENERATED: 'bg-gray-100 text-gray-800',
}

export const getStatementStatusClasses = (status) => {
    return STATEMENT_STATUS_CLASSES[status] || 'bg-gray-100 text-gray-800'
}
